import 'flag-icon-css/css/flag-icon.css';

import { ChallengeResult, closeChallengeDialog } from '../../../modules/challenge';
import { CircularProgress, TextField, Typography } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../../modules';
import React, { ChangeEvent, Component, Fragment, FormEvent } from 'react';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { authenticate as soapAuthenticate, challenge as soapChallenge } from '../../../modules/api';

import Button from '@material-ui/core/Button';
import ChallengeRequestProps from './ChallengeRequestProps';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const styles = (theme: Theme) => createStyles({
  progress: {
    display: 'block',
    margin: `${theme.spacing(2)}px auto`,
  },
  dialogActions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  error: {
    color: theme.palette.error.main
  },
  contactList: {
    maxWidth: theme.spacing(50),
    margin: `0 auto`,
  },
  contact: {
    cursor: 'pointer',
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
  },
  chevron: {
    marginLeft: theme.spacing(2),
  },
})

type State = {
  loading: boolean
  statusCode: string
  timeoutId: ReturnType<typeof setTimeout> | null
  error: string,
  otp: string 
  
};

class PushOtpChallengeRequest extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      loading: true,
      statusCode: "",
      error: "",
      timeoutId: null,
      otp: ""
    }
  }

  readonly QueryAuthStatusInterval = 5

  componentDidMount() {
    this.handleChallenge()
    this.setState({ loading: false })
  }

  handleChallenge = () => {
    let args = {
      credentialChallengeRequestList: {
        acspChallengeRequestData: {
          payload: {
            $attributes: {
              $xsiType: {
                type: "OTPMobileAppChallengeRequest",
                xmlns: "http://ws.otpmobileapp.csd.rsa.com"
              }
            }
          }
        }
      },
      eventDataList: {
        eventData: {
          eventType: this.props.challenge.analyzeRequest.eventDataList.eventData.eventType
        },
      }
    }

    this.setState({
      loading: true,
    })
    this.props.soapChallenge(args).then((data: any) => {
      try {
        let callStatus = data.credentialChallengeList.acspChallengeResponseData.callStatus

        if (callStatus.statusCode !== "SUCCESS")
          throw new Error("Received response status code: " + callStatus.statusCode)

        this.setState({
          loading: false,
          statusCode: callStatus.statusCode,
        })

      } catch (error) {
        console.error(error)
        this.setState({ loading: false, error: "Error sending challenge request" })
      }
    }).catch((error: Error) => {
      console.error(error)
      this.setState({ loading: false, error: "Error sending challenge request" })
    })
  }

  handleAuthenticate = (e: FormEvent) => {
    e.preventDefault()
    console.log("handleauth")
    const { otp } = this.state
    console.log(this.state)
    console.log('otp:', otp)
    // let otpinput = this.state.otp
    let args = {
      credentialDataList: {
        acspAuthenticationRequestData: {
          payload: {
            $attributes: {
              $xsiType: {
                type: "OTPMobileAppAuthenticationRequest",
                xmlns4: "http://ws.otpmobileapp.csd.rsa.com",
                xmlns: "http://ws.otpmobileapp.csd.rsa.com"
              }
            },
            otp

          }
        }
      }
    }
    this.props.soapAuthenticate(args)
      .then((data: any) => {
        if (data.credentialAuthResultList.acspAuthenticationResponseData.callStatus.statusCode === "SUCCESS") {
          this.props.challengeResponse(ChallengeResult.Success)
        }
        else {
          this.props.challengeResponse(ChallengeResult.Failure)
        }
      }).catch((error: Error) => {
        this.props.challengeResponse(ChallengeResult.Error)
      })
  }
    
  handleBack = () => {
    this.props.challengeResponse(ChallengeResult.Pending)
  }

  handleOtpChange(e: ChangeEvent<HTMLInputElement>) {
    this.setState({
      otp: e.target.value
    })
  }

  render() {
    const { loading, error } = this.state
    const { classes } = this.props

    return (
      <Fragment>
        {loading && !error &&
          <CircularProgress className={classes.progress} />
        }

        {!loading &&
         < Fragment>
            <DialogContent>
              <Typography className={classes.error}>{error}</Typography>
              <DialogContentText>
                Enter the OTP sent to Mobile App
              </DialogContentText>
              <form onSubmit={this.handleAuthenticate}>
                <TextField
                  autoFocus
                  margin="dense"
                  id="otp"
                  label="OTP"
                  type="text"
                  onChange={this.handleOtpChange.bind(this)}
                  fullWidth
                />
              </form>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button onClick={this.handleAuthenticate} color="primary">
                Authenticate
              </Button>
              <Button onClick={this.handleBack} color="default">
                Back
              </Button>
            </DialogActions>
          </Fragment>
        }
      </Fragment>
    )
  }
}


const mapStateToProps = ({ auth, authmethods, challenge }: IStoreState) => ({
  auth,
  authmethods,
  challenge
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      soapChallenge,
      soapAuthenticate,
      closeChallengeDialog
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, ChallengeRequestProps {
  // refer to ChallengeRequestProps.ts
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PushOtpChallengeRequest));